import React from 'react';
import { Radio as AntRadio } from 'antd';
import { RadioProps } from 'antd/lib/radio';

import cn from 'classnames';
import styles from './Radio.module.scss';

export type IRadioProps = RadioProps;

/**
 * Radio component
 */
const InternalRadio: React.ForwardRefRenderFunction<HTMLElement, IRadioProps> =
  React.memo(function InternalRadio(props, ref) {
    const { className } = props;

    return (
      <AntRadio className={cn(styles.Radio, className)} {...props} ref={ref} />
    );
  });

export default InternalRadio;
